export const STORAGE_USER = `MENTORSHIP`;
export const STORAGE_USER_DATA = `SavedLoggedInData`;
export const IS_LOADING = "IS_LOADING";
export const AUTH_USER_DATA = `authData`;
export const HOME_DATA = "HOME_DATA";
export const GET_A_MENTOR_FORM = "GET_A_MENTOR_FORM";
export const LOGIN_DATA = "LOGIN_DATA";
export const FACEBOOK_LOGIN = "FACEBOOK_LOGIN";
export const USER_PASS = "Enter Valid Username Password";
export const REGISTER_MENTOR = "REGISTER_MENTOR";
export const DASHBOARD_PROFILE_DATA = "DASHBOARD_PROFILE_DATA";
export const DASHBOARD_ADMIN_DATA = "DASHBOARD_ADMIN_DATA";
export const DASHBOARD_MENTOR_MYREQUEST = "DASHBOARD_MENTOR_MYREQUEST";
export const DASHBOARD_STARTUP_MYREQUEST = "DASHBOARD_STARTUP_MYREQUEST";
export const DASHBOARD_MENTOR_HOME = "DASHBOARD_MENTOR_HOME";
export const DASHBOARD_STARTUP_HOME = "DASHBOARD_STARTUP_HOME";
export const EXPORT_EXCEL_MENTOR = "EXPORT_EXCEL_MENTOR";
export const EXPORT_EXCEL_STARTUP = "EXPORT_EXCEL_STARTUP";
export const EXPORT_EXCEL_COHORT = "EXPORT_EXCEL_COHORT";
export const ADMIN_DASHBOARD_MENTOR_APPLICATION ="ADMIN_DASHBOARD_MENTOR_APPLICATION";
export const ADMIN_DASHBOARD_MENTOR_REQUEST ="ADMIN_DASHBOARD_MENTOR_REQUEST";
export const ADMIN_DASHBOARD_COHORT_GRAPH_DATA ="ADMIN_DASHBOARD_COHORT_GRAPH_DATA";
export const PUBLIC_GROUP_SESSIONS ="PUBLIC_GROUP_SESSIONS";
export const ADMIN_DASHBOARD_MENTOR_GRAPH_DATA ="ADMIN_DASHBOARD_MENTOR_GRAPH_DATA";
export const COHORT_GROUP_SESSION_HOURS ="COHORT_GROUP_SESSION_HOURS";
export const COHORT_GROUP_SESSION_HOURS_FILTER ="COHORT_GROUP_SESSION_HOURS_FILTER";
export const POST_COHORT_PROGRAM_SPOTLIGHT ="POST_COHORT_PROGRAM_SPOTLIGHT";
export const MENTOR_LIST = "MENTOR_LIST";
export const MENTOR_REQUEST_MENTORS_LIST = "MENTOR_REQUEST_MENTORS_LIST";
export const VIEW_APPLICATION_DATA = "VIEW_APPLICATION_DATA";
export const VIEW_PREDEFINED_OPTIONS = "VIEW_PREDEFINED_OPTIONS";
export const GUIDED_INSTRUCTIONS = "GUIDED_INSTRUCTIONS";
export const APPLICATION_STATUS = "APPLICATION_STATUS";
export const VIEW_STARTUP_APPLICATION_DATA = "VIEW_STARTUP_APPLICATION_DATA";
export const VIEW_COHORT_APPLICATION_DATA = "VIEW_COHORT_APPLICATION_DATA";
export const VIEW_MENTOR_APPLICATION_DATA = "VIEW_MENTOR_APPLICATION_DATA";
export const VIEW_COUNTER_OPTIONS = "VIEW_COUNTER_OPTIONS";
export const VIEW_COUNTER_SESSIONS = "VIEW_COUNTER_SESSIONS";
export const VIEW_COUNTER_HOURS = "VIEW_COUNTER_HOURS";
export const VIEW_COUNTER_STARTUP_OPTIONS = "VIEW_COUNTER_STARTUP_OPTIONS";
export const VIEW_COUNTER_MENTOR_OPTIONS = "VIEW_COUNTER_MENTOR_OPTIONS";
export const COUNTER_COHORT_APPLICATION = "COUNTER_COHORT_APPLICATION";
export const MENTOR_COHORT_APPLICATION_LIST = "MENTOR_COHORT_APPLICATION_LIST";
export const ADMIN_COHORT_APPLICATION_STATUS = "ADMIN_COHORT_APPLICATION_STATUS";
export const MENTOR_MODULE_COHORT_LIST = "MENTOR_MODULE_COHORT_LIST";
export const MENTOR_MODULE_STARTUP_COHORT_LIST = "MENTOR_MODULE_STARTUP_COHORT_LIST";
export const COHORT_DASHBOARD_ACTIVITY = "COHORT_DASHBOARD_ACTIVITY";
export const COHORT_DASHBOARD_MENTORS_COUNTER = "COHORT_DASHBOARD_MENTORS_COUNTER";
export const COHORT_DASHBOARD_STARTUP_COUNTER = "COHORT_DASHBOARD_STARTUP_COUNTER";
export const MENTOR_MODULE_STARTUP_COHORT_STATUS = "MENTOR_MODULE_STARTUP_COHORT_STATUS";
export const MENTOR_MODULE_MENTOR_COHORT_STATUS = "MENTOR_MODULE_MENTOR_COHORT_STATUS";
export const MENTOR_MODULE_STARTUP_COHORT_COUNTER = "MENTOR_MODULE_STARTUP_COHORT_COUNTER";
export const MENTOR_MODULE_MENTOR_COHORT_COUNTER = "MENTOR_MODULE_MENTOR_COHORT_COUNTER";
export const VIEW_MENTORLIST_COUNTER_OPTIONS =
  "VIEW_MENTORLIST_COUNTER_OPTIONS";
export const CONTACT_SUBMIT_DATA = "CONTACT_SUBMIT_DATA";
export const FAQ_PAGE_DATA = "FAQ_PAGE_DATA";
export const MENTORSHIP_REQUESTS_COUNTER = "MENTORSHIP_REQUESTS_COUNTER";
export const COHORT_REQUEST_STARTUP_DASHBOARD ="COHORT_REQUEST_STARTUP_DASHBOARD";
export const COHORT_REQUEST_MENTOR_DASHBOARD ="COHORT_REQUEST_MENTOR_DASHBOARD";
export const ABOUT_US = "About Us";
export const BECOME_MENTOR_DATA = "BECOME_MENTOR_DATA";
export const BECOME_MENTOR_LIST = "BECOME_MENTOR_LIST";
export const COHORT_DATA = "COHORT_DATA";
export const GET_A_MENTOR_DATA = "GET_A_MENTOR_DATA";
export const GET_SINGLE_MENTOR_DATA = "GET_SINGLE_MENTOR_DATA";
export const ALL_STARTUP_LIST = "ALL_STARTUP_LIST";
export const STARTUP_APPLICATIONS = "STARTUP_APPLICATIONS";
export const MENTORSHIP_APPLICATION = "MENTORSHIP_APPLICATION";
export const COHORTS_COMMON_DASHBOARD = "COHORTS_COMMON_DASHBOARD";
export const COHORTS_DISCUSSION_POST = "COHORTS_DISCUSSION_POST";
export const COHORTS_DISCUSSION_LIST = "COHORTS_DISCUSSION_LIST";
export const COHORTS_DISCUSSION_COMMENT_LIST = "COHORTS_DISCUSSION_COMMENT_LIST";
export const COHORTS_DISCUSSION_POST_COMMENT = "COHORTS_DISCUSSION_POST_COMMENT";
export const COHORTS_DISCUSSION_POST_LIKE = "COHORTS_DISCUSSION_POST_LIKE";
export const COHORTS_DISCUSSION_POST_UNLIKE = "COHORTS_DISCUSSION_POST_LIKE";
export const COHORTS_COMMENT_POST_UNLIKE = "COHORTS_COMMENT_POST_UNLIKE";
export const COHORTS_COMMENT_POST_LIKE = "COHORTS_COMMENT_POST_LIKE";
export const COHORTS_THREAD_REMOVE_POST = "COHORTS_THREAD_REMOVE_POST";
export const COHORTS_COMMENT_REMOVE_POST = "COHORTS_COMMENT_REMOVE_POST";
export const COHORTS_COMMENT_REPLY_POST = "COHORTS_COMMENT_REPLY_POST";
export const COHORTS_COMMENT_REPLY_LIST = "COHORTS_COMMENT_REPLY_LIST";
export const MENTORSHIP_STARTUP_APPLICATION_STATUS =
  "MENTORSHIP_STARTUP_APPLICATION_STATUS";
export const MENTORSHIP_STARTUP_APPLICATION = "MENTORSHIP_STARTUP_APPLICATION";
export const SET_SELECTED_MENU = "SET_SELECTED_MENU";
export const GET_SESSION_DATA = "GET_SESSION_DATA";
export const GET_SUMMARY_DATA = "GET_SUMMARY_DATA";
export const LOGIN_TWITTER_DATA = "LOGIN_TWITTER_DATA";
export const LOGIN_STARTUP_INDIA_DATA = "LOGIN_STARTUP_INDIA_DATA";
export const SESSIONS_SUMMARY_DATA = "SESSIONS_SUMMARY_DATA";
export const SESSIONS_SUMMARY_POST_DATA = "SESSIONS_SUMMARY_POST_DATA";
export const SESSIONS_MENTOR_SUMMARY_POST_DATA =
  "SESSIONS_MENTOR_SUMMARY_POST_DATA";
export const SESSIONS_DELETE_DATA = "SESSIONS_DELETE_DATA";
export const DELETE_MESSAGE_DATA = "DELETE_MESSAGE_DATA";
export const UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT";
export const ENGAGEMENT_NOTES = "ENGAGEMENT_NOTES";
export const GET_ENGAGEMENT_NOTES = "GET_ENGAGEMENT_NOTES";
export const UPLOAD_PROGRESS_REPORT = "UPLOAD_PROGRESS_REPORT";
export const IM_SEND_MESSAGES = "IM_SEND_MESSAGES";
export const IM_ALL_MESSAGES = "IM_ALL_MESSAGES";
export const UPLOAD_DOCUMENT_LIST = "UPLOAD_DOCUMENT_LIST";
export const POST_STARTUP_FEEDBACK = "POST_STARTUP_FEEDBACK";
export const GET_STARTUP_FEEDBACK = "GET_STARTUP_FEEDBACK";
export const POST_MENTOR_FEEDBACK = "POST_MENTOR_FEEDBACK";
export const GET_MENTOR_FEEDBACK = "GET_MENTOR_FEEDBACK";
export const SESSION_CALENDAR = "SESSION_CALENDAR";
export const ALL_STARTUP_APPLICATION_LIST="ALL_STARTUP_APPLICATION_LIST";
export const GET_NAMES_LIST = "GET_NAMES_LIST";
export const NEW_MESSAGE_DISPLAY = "NEW_MESSAGE_DISPLAY";
export const MATCH_COHORT_LIST = "MATCH_COHORT_LIST";
export const MATCH_STARTUP_LIST = "MATCH_STARTUP_LIST";
export const MATCH_MENTOR_LIST = "MATCH_MENTOR_LIST";
export const MATCH_COHORT_REQUEST = "MATCH_COHORT_REQUEST";
export const MY_MENTORS_COUNTER = "MY_MENTORS_COUNTER";
export const MY_STARTUPS_COUNTER = "MY_STARTUPS_COUNTER";
export const MATCH_RESULT_LIST = "MATCH_RESULT_LIST";
export const ACTIVITY_SUMMARY_DASHBOARD = "ACTIVITY_SUMMARY_DASHBOARD";
export const ACTIVITY_SUMMARY_MENTORSHIP_COUNT = "ACTIVITY_SUMMARY_MENTORSHIP_COUNT";
export const ACTIVITY_SUMMARY_MENTORSHIP_TOTAL = "ACTIVITY_SUMMARY_MENTORSHIP_TOTAL";
export const ACTIVITY_SUMMARY_MENTORSHIP_STATUS = "ACTIVITY_SUMMARY_MENTORSHIP_STATUS";
export const ACTIVITY_SUMMARY_STARTUP_COUNT = "ACTIVITY_SUMMARY_STARTUP_COUNT";
export const ACTIVITY_SUMMARY_COHORT_COUNT = "ACTIVITY_SUMMARY_COHORT_COUNT";
export const ACTIVITY_SUMMARY_PERFORMANCE = "ACTIVITY_SUMMARY_PERFORMANCE";
export const ACTIVITY_SUMMARY_NULL = "ACTIVITY_SUMMARY_NULL";
export const ACTIVITY_SUMMARY_LOW_ACTIVITY = "ACTIVITY_SUMMARY_LOW_ACTIVITY";
export const CREATE_COHORT_GROUP_SESSION = "CREATE_COHORT_GROUP_SESSION";
export const DELETE_COHORT_GROUP_SESSION = "DELETE_COHORT_GROUP_SESSION";
export const DETAILS_COHORT_GROUP_SESSION = "DETAILS_COHORT_GROUP_SESSION";
export const LIST_COHORT_GROUP_SESSION = "LIST_COHORT_GROUP_SESSION";
export const GROUP_SESSION_CHANGE_STATUS = "GROUP_SESSION_CHANGE_STATUS";
export const LIST_SESSION_MEMBER_LIST = "LIST_SESSION_MEMBER_LIST";
export const LIST_COHORT_GROUP_SESSION_COUNTER = "LIST_COHORT_GROUP_SESSION_COUNTER";
export const COHORT_SESSION_INVITATION_LIST = "COHORT_SESSION_INVITATION_LIST";
export const COHORT_SESSION_GIVE_FEEDBACK = "COHORT_SESSION_GIVE_FEEDBACK";
export const COHORT_SESSION_VIEW_FEEDBACK = "COHORT_SESSION_VIEW_FEEDBACK";
export const COHORT_SESSION_NOTES_GIVE_FEEDBACK = "COHORT_SESSION_NOTES_GIVE_FEEDBACK";
export const COHORT_SESSION_NOTES_VIEW_FEEDBACK = "COHORT_SESSION_NOTES_VIEW_FEEDBACK";
export const COHORT_SPOTLIGHT_LIST = "COHORT_SPOTLIGHT_LIST";
export const COHORT_SPOTLIGHT_CALENDAR = "COHORT_SPOTLIGHT_CALENDAR";
export const PRODUCTION_MOVE_HIDDEN=false;
export const SITE_KEY="6Ld112UUAAAAAITPMregPN1avoXBSMtFeOfra0_r";
export const PROFILE_KEY="77d184qms6a5ug999012";

export const isLoading = (data) => {
  return {
    type: IS_LOADING,
    payload: data,
  };
};
